import { Option } from "@jutro/types";
import {
  EdmGenreType,
  EdmLeaveType,
  EdmMedicalAppVisitType,
} from "lib/graphql/megaSchema";

export type StaffGenreFilter =
  | Extract<EdmGenreType, "DOCTOR" | "NURSE" | "MIDWIFE">
  | "ALL";

export const staffGenreFilterOptions: Option<StaffGenreFilter>[] = [
  { label: "Cały personel", value: "ALL" },
  { label: "Lekarze", value: "DOCTOR" },
  { label: "Pielęgniarki", value: "NURSE" },
  { label: "Położne", value: "MIDWIFE" },
];

export const visitTypeLabelMap: Record<EdmMedicalAppVisitType, string> = {
  IN_PERSON: "Osobista",
  TELEMEDICAL: "Telemedyczna",
  DOCTOR_TELEMEDICAL_INFECTION: "Telemedyczna infekcyjna",
  NURSE_IN_PERSON_INFECTION: "Infekcyjna pielęgniarska",
  PROCEDURE: "Zabiegowa",
  COLLECTION: "Pobraniowa",
  DOCTOR_HOUSE_CALL: "Domowa",
  NURSE_HOUSE_CALL: "Domowa",
  RADIOLOGY_APPOINTMENT: "USG",
  PRESCRIPTION_APPOINTMENT: "Receptowa",
  EXPRESS_APPOINTMENT: "Ekspresowa",
  SICK_CHILDREN: "Dzieci chore",
  SPECIALIST: "Specjalistyczna",
  MIDWIFE_HOUSE_CALL: "Patronaż",
  MIDWIFE_IN_PERSON: "Edukacja przedporodowa",
  DIETETICS: "Dietetyczna",
  HEALTHY_CHILDREN_CHECKUP: "Dzieci bilans",
  HEALTHY_CHILDREN_CHECKUP_AND_VACCINE: "Dzieci bilans + szczepienie",
  HEALTHY_CHILDREN_PATRONAGE: "Dzieci patronaż",
  HEALTHY_CHILDREN_VACCINE: "Dzieci szczepienia",
  NURSE_IN_PERSON: "Osobista pielęgniarska",
  NURSE_HEALTHY_CHILDREN: "Dzieci zdrowe",
};

export const leaveTypeLabelMap: Record<EdmLeaveType, string> = {
  BREAK: "Przerwa",
  ILLNESS: "Choroba",
  OFFICE_VENTILATION: "Wietrzenie",
  OVERTIME: "Nadgodziny",
  PAID_HOLIDAY: "Urlop płatny",
  UNPAID_HOLIDAY: "Urlop bezpłatny",
  MEETING: "Zebranie",
};

export const staffIdsWithNurseVisitTypes = [
  "6020d907ffb84e5e761b22ee", // Polozna Testowa
  "65fc680e12d0953f1a00a7a2", // Agata Witkowicz
];
